import React from 'react';
import { Stack, Text } from '@moda/om';
import { RestAddress } from '../../../hooks/useAddress';
import { ShippingAddressPreview } from '../../ShippingAddress';

type Props = {
  address: RestAddress;
};

export const AmazonShippingAddressPreview: React.FC<Props> = ({ address }) => (
  <Stack space={0}>
    <Stack space={1} direction="horizontal" alignItems="center">
      <img src="/dist/public/amazon_payments.png" alt="Amazon Payments" />
      <Text treatment="eyebrow">Shipping Address</Text>
    </Stack>
    <ShippingAddressPreview attributes={address.attributes} />
  </Stack>
);
